import * as React from "react";
import Scroll from '../Scroll/Scroll'
import './SiteDescription.scss'

const SiteDescription = (props) => {

  const {location, children, refObj} = props

  return (
      <div ref={refObj} className="site-description" style={{
          top: `${location.pos.y}px`,
          left: `${location.pos.x}px`,
      }} >
          <h2>{location.name}</h2> 

          <div className="site-description-content">
            <span>{location.coords.dms.lat}</span>
            <span>{location.coords.dms.lon}</span>
            <Scroll>
              <p>{location.description}</p>
            </Scroll>
            {children}
          </div>
      </div>
  );
}

export default SiteDescription;

